module.exports = __webpack_public_path__ + "static/media/feitosa.49c83728.png";